import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VendorInfo from '../forms/VendorInfo';
import { zipcodeLookup } from '~/accounts/signup/actions';

class UpdateVendorWrapper extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'onZipcodeChange', 'handleSubmit');

    this.state = {
      vendorForm: props.initialValues
    };
  }

  onZipcodeChange(e, zipCode) {
    if (zipCode.length < 5) {
      return;
    }

    zipcodeLookup(zipCode, (json) => {
      this.setState({
        vendorForm: Object.assign({}, this.state.vendorForm, {
          city: json.city,
          state: json.state
        })
      });
    });
  }

  handleSubmit(values) {
    const { vendorUpdateAction } = this.props;

    vendorUpdateAction(Object.assign({ has_completed_signup: true }, values));
  }

  render() {
    const { onFormChange } = this.props;
    const { vendorForm } = this.state;

    return (
      <VendorInfo
        initialValues={vendorForm}
        enableReinitialize={true}
        keepDirtyOnReinitialize={true}
        onSubmit={this.handleSubmit}
        onChange={onFormChange}
        onZipcodeChange={this.onZipcodeChange}
      />
    );
  }
}

UpdateVendorWrapper.defaultProps = {
  initialValues: {}
};

UpdateVendorWrapper.propTypes = {
  vendorUpdateAction: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  onFormChange: PropTypes.func,
};

export default UpdateVendorWrapper;
